import React, { useEffect } from "react";
import { leavesService } from "../../../../api/services/leavesService";
import { useAppSelector } from "../../../../infra/hooks";

const DTOLeaveAppliedViewModal = () => {
  return <></>;
};

export default DTOLeaveAppliedViewModal;
